export default "__VITE_ASSET__BnOrBgjQ__"